import { render, staticRenderFns } from "./CommercialTermRule.vue?vue&type=template&id=0a243d70"
import script from "./CommercialTermRule.vue?vue&type=script&lang=js"
export * from "./CommercialTermRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports